import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    id: String
  }

  async add(event) {
    event.preventDefault()
    const button = event.currentTarget
    button.disabled = true
    button.textContent = "Adding..."

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({
          sites_layout_element: {
            element_id: this.idValue,
            position: document.querySelectorAll("[data-layout-element]").length
          }
        })
      })

      if (!response.ok) {
        throw new Error("Failed to add element")
      }

      // Refresh the page to show the new element
      window.location.reload()
    } catch (error) {
      console.error("Error adding element:", error)
      button.textContent = "Add to Layout"
      button.disabled = false
    }
  }
}